import { html, TemplateResult, CSSResultGroup } from 'lit';
import { customElement, property } from 'lit/decorators.js';

// Our base component, which all others extend.
import { OutlineElement } from '../../base/outline-element/outline-element';
import componentStyles from './co-work-progress-project-card.css.lit';
import defaultImageUrl from './assets/default-image.png';

/**
 * The Coninsa Work Progress Project Card component
 * @slot - The default, and only slot for this element.
 */
@customElement('co-work-progress-project-card')
export class CoWorkProgressProjectCard extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  /**
   * Property type.
   */
  @property()
  type: string;

  /**
   * Location.
   */
  @property()
  location: string;

  /**
   * Brand.
   */
  @property()
  brandUrl: string;

  /**
   * Url.
   */
  @property()
  url: string;

  /**
   * Image.
   */
  @property()
  imageUrl?: string;

  actionsTemplate(): TemplateResult {
    return html`
      <div class="actions">
        <slot></slot>
      </div>
    `;
  }

  render(): TemplateResult {
    const imagePropertyUrl = this?.imageUrl || defaultImageUrl;

    return html`
      <a class="card" href=${this.url} target="_blank">
        <div class="image">
          <img src=${imagePropertyUrl} />
        </div>
        <div class="info">
          <div class="brand">
            <img src=${this.brandUrl} />
          </div>
          <div class="type">${this.type}</div>
          <div class="place">${this.location}</div>
        </div>
        ${this.actionsTemplate()}
      </a>
    `;
  }
}
